
import { Options, prop, Vue } from "vue-class-component";
import formatPriceRP from "@/app/infrastructures/misc/common-library/v2/FormatPriceRP";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import startCase from "lodash/startCase";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import formatPriceRM from "@/app/infrastructures/misc/common-library/v2/FormatPriceRM";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BookingV3 } from "@/domain/entities/CreateBookingV3";
import { configPrice } from "@/app/infrastructures/misc/common-library/modules/Price";
import { formatByCountry } from '@/app/infrastructures/misc/Utils';

class Props {
  isShow = prop<boolean>({
    default: false,
    type: Boolean
  });
  showProductType = prop<boolean>({
    default: false,
    type: Boolean
  });
  dataDetail = prop<any>({
    default: {},
    type: Object
  });
  isDiscountActive = prop<boolean>({
    default: false,
    type: Boolean
  });
  isCodRetail = prop<boolean>({
    default: false,
    type: Boolean
  });
  isCOD = prop<boolean>({
    default: false,
    type: Boolean
  });
  isDFOD = prop<boolean>({
    default: false,
    type: Boolean
  });
  isForeignCurrency = prop<boolean>({
    default: false,
    type: Boolean
  });
  goodsValue = prop<any>({
    default: "0"
  });
  listDiscount = prop<any[]>({
    default: () => [],
    type: Array
  });
  voucherCode = prop<string>({
    default: "",
    type: String
  });
  form = prop<BookingV3>({
    default: () => new BookingV3(),
    type: BookingV3
  });
  isCrossCountryCOD = prop<boolean>({
    default: false,
    type: Boolean
  });
  codCurrencyCode = prop<string>({
    default: "IDR",
    type: String
  });
}

@Options({})
export default class DetailEstimation extends Vue.with(Props) {
  get isEnableCodBooking() {
    return FlagsMedusa.config_new_cod_booking_enable.isEnabled();
  }

  currency(curr: number) {
    return formatByCountry(curr, {
      type: "money",
      country: AccountController.accountData.countryCode?.toUpperCase(),
      prefix: this.isForeignCurrency ? "RM" : "Rp",
    });
  }

  // COD Amount / Biaya COD render in destination currency for cross-country
  // COD — everything else in this popover stays on origin currency via
  // currency() above (Total Tarif is always origin currency, per GENESIS-21769).
  currencyCod(curr: number) {
    const config = configPrice[this.codCurrencyCode] ?? configPrice.IDR;
    if (!curr) return `${config.prefix}0`;
    return `${config.prefix}${curr.toLocaleString(config.locales)}`;
  }

  get codReturnFee() {
    return this.dataDetail.totalTariff > 0
      ? (this.dataDetail.totalTariff - this.dataDetail.codFee) * 0.5
      : 0;
  }

  get isCODOnly() {
    return this.isCOD === true && this.isDFOD === false;
  }

  startCase(value: string) {
    return startCase(value);
  }

  formatDateWithoutTime(value: string) {
    return formatDateWithoutTime(value);
  }

  refs: any = {};
  onOpenTooltipPromo(event: any, index: number) {
    const refs: any = this.$refs;
    refs[`infoPromo${index}`].toggle(event);
  }

  get accountIsForeign() {
    return AccountController.accountData.accountIsForeign;
  }
}
